
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h14v14H0z"}}),_c('path',{attrs:{"fill":"#9AA5B7","fill-rule":"nonzero","d":"M7.875.875v5.25h5.25v1.75h-5.25v5.25h-1.75v-5.25H.875v-1.75h5.25V.875z"}})])])
          )
        }
      }
    